import axios, { AxiosError, AxiosInstance } from 'axios'
import { Landing } from '../pages/landing'
import toast from '../components/Toast'
import { ConnectionDetails } from '../components/VoiceRoom'
// import toast from "./components/Toast"

const apiInstance: AxiosInstance = axios.create({
  withCredentials: false,
  baseURL: 'https://survey-back-prod-688866272103.europe-west2.run.app'
  //baseURL: 'http://localhost:4000'
})

apiInstance.interceptors.response.use(
  response => {
    return response
  },

  error => {
    if (error.response !== null && error.response !== undefined && error.response.status === 403) {
      if (error?.response?.data?.description === 'please login') {
        // get the current location pathname
        window.location.replace(`/login?next=${window.location.href}`)
      }
    }
    return Promise.reject(error)
  }
)

export class Api {
  private apiInstance: AxiosInstance // This is private and stays private. Create specific functions bellow with strongly typed parameters for each route

  constructor(instance: AxiosInstance) {
    this.apiInstance = instance
  }

  private setupLanding = (l?: Landing): Landing => {
    return {
      desktop: l?.desktop ?? {},
      mobile: l?.mobile ?? l?.desktop ?? {},
      tablet: l?.tablet ?? l?.desktop ?? {}
    }
  }

  getLanding = async (
    campaignId: string,
    preview: boolean
  ): Promise<{
    landing: Landing
    language: string
    primaryColor?: string
    secondaryColor?: string
  }> => {
    try {
      const result = await this.apiInstance.post('/landing', { campaignId, preview })
      return {
        landing: this.setupLanding(result.data.landing as Landing),
        language: result.data.landing.language,
        primaryColor: result.data.landing.primaryColor,
        secondaryColor: result.data.landing.secondaryColor
      }
    } catch (error: unknown) {
      if ((error as AxiosError)?.response?.status === 401) {
        console.log(error)

        toast.error(((error as AxiosError)?.response?.data as { description: string })?.description)
      } else toast.error('Failed to load landing')

      throw error
    }
  }

  init = async (
    campaignId: string,
    visitorId: string,
    preview: boolean,
    thirdpartyId?: string,
    stt?: string,
    tts?: string
  ): Promise<ConnectionDetails> => {
    try {
      const result = await this.apiInstance.post('/init', {
        campaignId,
        visitorId,
        preview,
        thirdpartyId,
        stt,
        tts
      })
      return result.data.data as ConnectionDetails
    } catch (error: unknown) {
      if ((error as AxiosError)?.response?.status === 401) {
        console.log(error)
        toast.error(((error as AxiosError)?.response?.data as { description: string })?.description)
      } else {
        toast.error('Init Failed')
      }
      throw error
    }
  }
}

const api = new Api(apiInstance)

export default api
